import { ListItem as MUIListItem, ListItemProps } from '@mui/material';
import { mergeSX } from '../../../../services/helpers';

export interface IListItemProps extends ListItemProps {}

const buildSX = () => ({
  padding: 0,
  '& .MuiIconButton-root:hover': {
    backgroundColor: 'initial',
  },
});

const ListItem = (props: IListItemProps) => {
  const { children, sx, ...restProps } = props;
  return <MUIListItem sx={mergeSX(buildSX(), sx)} {...restProps}>{children}</MUIListItem>;
};

export default ListItem;
